module.exports = __webpack_public_path__ + "img/qr_service.5a2b2c94.jpg";